module.exports = __webpack_public_path__ + "static/scania-r500-2-a9980ddfa226fd9877b0b19b3ac18418.jpg";